import { render } from "./DeliveryStatistics.vue?vue&type=template&id=5fa3abeb&scoped=true&ts=true"
import script from "./DeliveryStatistics.vue?vue&type=script&lang=ts"
export * from "./DeliveryStatistics.vue?vue&type=script&lang=ts"

import "./DeliveryStatistics.vue?vue&type=style&index=0&id=5fa3abeb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa3abeb"]])

export default __exports__